/**
 * Shared ZAR currency formatting utilities.
 * All cent-to-rand formatting in the frontend goes through here.
 */

const ZAR_FORMAT = new Intl.NumberFormat('en-ZA', {
  style: 'currency',
  currency: 'ZAR',
  minimumFractionDigits: 2,
});

/** Format a cent amount as a ZAR currency string (e.g. "R 100.00"). */
export function formatZAR(cents: number): string {
  return ZAR_FORMAT.format(cents / 100);
}
